import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=73ce5a92&"
import script from "./MessageNotification.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MessageNotification.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports